import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { CUL_BASIC_Schema } from './CUL_BASIC_Schema';
import { handleQuerySuccess } from '../../../../hooks/useQuriesSuccess';
import useSearchMutaion from './../../../../hooks/apis/useSearchMutaion';
import useSaveMutation from '../../../../hooks/apis/useSaveMutaion';
export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(CUL_BASIC_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['Dashboard', 'getMaiBasicR2', params],
    queryFn: () =>
      apiRequest('post', Global.urls.Dashboard.getMaiBasicR2, params),
    enabled: true, // 자동 실행 여부
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};
export const useSearch2 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const params = mapParamsBySchema(CUL_BASIC_Schema.mapper.search2, context);
    const response = await apiRequest(
      'post',
      Global.urls.Dashboard.getMaiBasicR3,
      params
    );
    // eslint-disable-next-line no-console -- getMaiBasicR3 디버깅
    console.log('[getMaiBasicR3] response', response);
    return response;
  }, successOptions);
};
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, CUL_BASIC_Schema.mapper.save1);
    return apiRequest('post1', Global.urls.Dashboard.saveMaiBasicU1, payload);
  }, options);
};
